/* src/app/components/order-report-incident/order-report-incident.component.scss */
.close-button {
  color: black;
  min-height: 0;
  --border-radius: 0;
}
.close-button::part(native) {
  padding: 0;
}
.close-button ion-icon {
  font-size: 20px !important;
}
.header ion-icon {
  font-size: 40px;
}
.header .title {
  gap: 15px;
  color: #ff007f;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
@media (max-width: 628px) {
  .header ion-icon {
    font-size: 40px;
    min-width: 28px;
  }
  .header .title {
    font-size: 28px !important;
  }
}
title {
  display: inline;
}
hr {
  margin: 20px 0;
}
.body-title {
  color: #000;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-bottom: 20px;
}
.body-text {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-top: 20px;
}
.commentBox_textarea {
  --border-style: none;
  border-color: #949494;
  border-width: 2px;
  padding: 14px;
  border-radius: 14px;
}
.textarea-bottom.sc-ion-textarea-ios {
  border-top: 0 none transparent !important;
}
.preview-container .preview-item {
  position: relative;
}
.preview-container .preview-item .remove-file-btn {
  z-index: 10;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
}
.preview-container .preview-item .remove-file-btn:hover {
  background-color: #b91c1c;
}
.preview-container .preview-item img,
.preview-container .preview-item video {
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
.select-file-btn {
  background-color: #ff007f;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 16px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}
.select-file-btn:hover:enabled {
  background-color: #e60073;
}
.select-file-btn:disabled {
  background-color: #e5e7eb;
  color: #949494;
  cursor: not-allowed;
}
/*# sourceMappingURL=order-report-incident.component-LKA7R7JK.css.map */
